import { SERVER_URL } from 'Constants/Server'
import axios from 'axios'

export const login = (data) => {
  const url = `${SERVER_URL}/api/Clients/login?include=user`
  return axios.post(url, data)
}
